import {
  type DemoProfile,
  type DemoRefreshResponse,
  disableDemo,
  enableDemo,
  refreshDemo,
} from '@lms/api-client/backend';

// Ports features/demo/actions.ts. The Next server actions called the backend and
// then `revalidatePath` for the settings and demo pages; here they are plain
// async functions returning a result the caller acts on, and revalidation is the
// caller's job via SWR `mutate`.

export type EnableDemoResult =
  | { ok: true; students: number; sessions: number }
  | { ok: false; error: string };

export async function enableDemoAction(
  locationId: number,
  profile: DemoProfile,
): Promise<EnableDemoResult> {
  try {
    const result = await enableDemo(locationId, profile);
    return { ok: true as const, ...result };
  } catch (e) {
    return { ok: false as const, error: String(e) };
  }
}

export type DisableDemoResult = { ok: true } | { ok: false; error: string };

export async function disableDemoAction(
  locationId: number,
): Promise<DisableDemoResult> {
  try {
    await disableDemo(locationId);
    return { ok: true as const };
  } catch (e) {
    return { ok: false as const, error: String(e) };
  }
}

export type RefreshDemoResult =
  | ({ ok: true } & DemoRefreshResponse)
  | { ok: false; error: string };

export async function refreshDemoAction(): Promise<RefreshDemoResult> {
  try {
    const result = await refreshDemo();
    return { ok: true as const, ...result };
  } catch (e) {
    return { ok: false as const, error: String(e) };
  }
}
